<template>
<v-container fluid>
<v-layout>
  <v-flex xs12>
    <v-card>
    <v-card-title>
      <v-flex xs5>
        <h5 class="accent--text" style="font-size: 12px; font-weight:700">Interest Commissions </h5>
      </v-flex>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="commissions"
      class="elevation-1"
      :search="search"
      disable-pagination
      :hide-default-footer="true"
    >
    <template v-slot:[`header.id`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.disbursementAmount`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.interestAmount`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`header.disbursementStatus`]="{ header }">
      <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
    </template>
    <template v-slot:[`item.dateCreated`]="{ item }">
       {{item.dateCreated | prettyDate }}
    </template>
    </v-data-table>
    <v-row>
        <v-col cols="12" sm="9">
          <v-pagination
            v-model="page"
            :length="totalPages"
            total-visible="7"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
          ></v-pagination>
        </v-col>
      </v-row>
   </v-card>
  </v-flex>
</v-layout>

</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import _ from 'lodash'

export default {
  name: 'vieworganization',
  data: function () {
    return {
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Amount', value: 'disbursementAmount' },
        { text: 'Interest', value: 'interestAmount' },
        { text: 'Status', value: 'disbursementStatus' },
        { text: 'Date', value: 'dateCreated' }
      ],
      commissions: [],
      search: '',
      page: 1,
      totalPages: 0,
      pageSize: 5,
      pageSizes: [5, 10]
    }
  },
  mounted () {
    this.getCommissions()
  },
  watch: {
    search: function (oldValue, newValue) {
      this.debouncedGetAnswer()
    }
  },
  methods: {
    getRequestParams (name, page, pageSize) {
      const params = {}
      if (page) {
        params.page = page - 1
      }
      if (pageSize) {
        params.size = pageSize
      }
      if (name) {
        params.name = name
      }
      return params
    },
    handlePageChange (value) {
      this.page = value
      this.getCommissions()
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getCommissions()
    },
    getCommissions: function () {
      const params = this.getRequestParams(
        this.search,
        this.page,
        this.pageSize
      )
      const url = config.serverURI + '/disbursement_transactions'
      axios.get(url, { params })
        .then(response => {
          const { items, totalPages } = response.data
          this.commissions = items
          this.totalPages = totalPages
        })
        .catch(error => {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
        })
      return this.organizations
    }
  },
  created: function () {
    this.debouncedGetAnswer = _.debounce(this.getOrganizations, 1000)
  }
}

</script>
<style>
</style>
